export default "__VITE_ASSET__DqdYtPEM__"